export default __webpack_public_path__ + "static/media/stupid.51828a78.mp3";